import React, { useEffect, useState } from "react";
import {
  getProductCount,
  getStoreCount,
  getStoreProductCount,
  getActiveProductCount,
  getDashboardOrders,
  getStore,
  getActiveStoreCount,
} from "../actions";
import { getTokenOrDefault } from "helpers/Storage";

export const useDashboard = () => {
  const [stores, setStores] = useState(0);
  const [products, setProducts] = useState(0);
  const [storeProduct, setStoreProduct] = useState(0);
  const [activeProduct, setActiveProduct] = useState(0);
  const [activeStore, setActiveStore] = useState(0);
  const [orders, setOrders] = useState([]);
  const [storeID, setStoreID] = useState<string | null>(null);

  const token = getTokenOrDefault();

  useEffect(() => {
    getStores();
    getProducts();
    getStoreProduct();
    getActiveProduct();
    getActiveStore();
    getOrders();
    getLatestStoreID();
  }, []);

  const getStores = async () => {
    const response: any = await getStoreCount(token);
    if (response.is_success && response.data !== null) {
      setStores(response.data);
    }
  };

  const getProducts = async () => {
    const response: any = await getProductCount(token);
    if (response.is_success && response.data !== null) {
      setProducts(response.data);
    }
  };

  const getStoreProduct = async () => {
    const response: any = await getStoreProductCount(token);
    if (response.is_success && response.data !== null) {
      setStoreProduct(response.data);
    }
  };

  const getActiveProduct = async () => {
    const response: any = await getActiveProductCount(token);
    if (response.is_success && response.data !== null) {
      setActiveProduct(response.data);
    }
  };

  const getActiveStore = async () => {
    const response: any = await getActiveStoreCount(token);
    if (response.is_success && response.data !== null) {
      setActiveStore(response.data);
    }
  };

  const getOrders = async () => {
    const response: any = await getDashboardOrders(token);
    if (response.is_success && response.data !== null) {
      setOrders(response.data);
    }
  };

  const getLatestStoreID = async () => {
    const response: any = await getStore(token, "");
    if (response.is_success && Array.isArray(response.data)) {
      const sortedStores = response.data.sort(
        (a: { created_at: string }, b: { created_at: string }) => {
          return (
            new Date(b.created_at).getTime() - new Date(a.created_at).getTime()
          );
        }
      );

      const latestStore = sortedStores[0];
      if (latestStore?.id) {
        setStoreID(latestStore.id);
      }
    }
  };

  return {
    stores,
    products,
    orders,
    storeProduct,
    activeProduct,
    activeStore,
    storeID,
  };
};
